import "./styles.css";
import "./styles.css";

import { WithStyles } from "@material-ui/core/styles";
import * as React from "react";

interface IProps {
  text: string;
}

export default class DistortedText extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const { text } = this.props;
    return (
      <div className="distorted-body">
        <div className="text">
          <div className="r">{text}</div>
          <div className="g">{text}</div>
          <div className="b">{text}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DistortedText/DistortedText.tsx